/**
 * @selector [data-js-print]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

export class PrintLink extends BaseModule {
    init(element) {
        this.el = element;

        this.el.addEventListener('click', (e) => {
            e.preventDefault();

            window.print();
        });

        return this;
    }
}

export default function createModule() {
    return new PrintLink();
}
